module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"dynamicText":"Du har valgt {count} ferdighet | Du har valgt {count} ferdigheter"},"en":{"dynamicText":"You have chosen {count} skill | You have chosen {count} skills"}}')
  delete Component.options._Ctor
}
